module.exports = __webpack_public_path__ + "img/Woman_Yoga_Outline.8d210540.svg";